import { Paper, Skeleton, styled } from "@mui/material";

export function ResultPageSkeleton() {
  return (
    <StyledPaper elevation={0}>
      <Skeleton width={"100%"} height={"100%"} className="total-score-grid" />
      <Skeleton width={"100%"} height={"100%"} className="share-grid" />
      <Skeleton width={"100%"} height={"100%"} className="theme-graph-grid" />
      <Skeleton width={"100%"} height={"100%"} className="cost-benefit-grid" />
      <Skeleton width={"100%"} height={"100%"} className="detail-grid" />
      <Skeleton width={"100%"} height={"100%"} className="leaflet-map-grid" />
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  background-color: transparent;
  height: 100%;
  flex-grow: 1;
  display: grid;
  gap: ${({ theme }) => theme.spacing(6)};
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 2%;
  margin-bottom: 2%;
  column-gap: ${({ theme }) => theme.spacing(10)};
  grid-template-areas:
    "totalScoreSection totalScoreSection"
    "themeGraphSection costBenefitsSection"
    "detailSection detailSection"
    "leafletMapSection leafletMapSection";
  grid-template-rows:
    minmax(0, 200px) minmax(500px, 500px) minmax(0, 200px)
    minmax(600px, 600px);
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

  .total-score-grid {
    grid-area: totalScoreSection;
  }
  .share-grid {
    grid-area: shareSection;
  }
  .theme-graph-grid {
    grid-area: themeGraphSection;
  }
  .cost-benefit-grid {
    grid-area: costBenefitsSection;
  }

  .detail-grid {
    grid-area: detailSection;
  }
  .leaflet-map-grid {
    grid-area: leafletMapSection;
  }
`;
